export default {
  type: 'editor.elements.BackgroundElement',
  id: 'background',
  name: 'Background',
  icon: 'M13,6l4,4H13V6Zm8-1V19a2,2,0,0,1-2,2H5a2,2,0,0,1-2-2V5A1.93,1.93,0,0,1,5,3H19a2,2,0,0,1,1.43.56A1.92,1.92,0,0,1,21,5Zm-2,5L14,5H6.51A1.45,1.45,0,0,0,5,6.51v11A1.5,1.5,0,0,0,6.51,19h11A1.5,1.5,0,0,0,19,17.49V10Z',
  staticElement: true,
  order: 10,
  tooltip: 'Design the space around your listing. Use it to emphasize the listing.',
};
